import {OperationStaffItem} from "../types/operation";

type GetOperationStaffNamesProps = {
  staffList: OperationStaffItem[]
  ids: string[]
}

export const getOperationStaffNames = (props: GetOperationStaffNamesProps) => {
  const {staffList, ids} = props

  return staffList
    .filter((staff) => ids.includes(staff.$id))
    .map((staff) => staff.fullName)

}